import { render, staticRenderFns } from "./FrontpageExperts.vue?vue&type=template&id=498d79e0&"
import script from "./FrontpageExperts.vue?vue&type=script&lang=js&"
export * from "./FrontpageExperts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports